$(document).ready(function() {
    var isRtl = $('html').attr('dir') === 'rtl' || $('body').attr('dir') === 'rtl';

    var initDatePicker = function() {
        $.fn.datepicker.dates['ru'] = {
            days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            daysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
            today: "Сегодня",
            clear: "Очистить",
            format: "mm/dd/yyyy",
            titleFormat: "MM yyyy",
            weekStart: 0
        };
        
        $('.datepicker-base').datepicker({
            format: 'dd.mm.yyyy',
            language: 'ru',
            orientation: isRtl ? 'auto right' : 'auto left'
        });
    };

    $('[data-toggle="cropper-example-tooltip"]').tooltip({ container: 'body' });
    $('[data-toggle="popover"]').popover();

    var initSelect2 = function() {
        $('.select2-demo').each(function() {
            $(this)
                .wrap('<div class="position-relative select-item-block"></div>')
                .select2({
                    placeholder: 'Не выбрано',
                    dropdownParent: $(this).parent(),
                    language: {
                        noResults: function () {
                            return "Нет доступных вариантов.";
                        }
                    }
                });
        })
    };

    // $('#nestable-menu').on('click', function(e) {
    //     var target = $(e.target);
    //     var action = target.data('action');

    //     if (action === 'expand-all') {
    //         $('.dd').nestable('expandAll');
    //     }
    //     if (action === 'collapse-all') {
    //         $('.dd').nestable('collapseAll');
    //     }
    // });

    // $('#nestable2').nestable({
    //     group: 1,
    //     handleClass: 'custom'
    // });

    $(window).on('shown.bs.modal', function() {
        initSelect2();
        initDatePicker();
    });

    initSelect2();
    initDatePicker();
});
